<template>
  <div class="p-4 bg-white dark:bg-gray-900 rounded-lg shadow">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-bold">Mosquito Control</h3>
      <button @click="autoMode = !autoMode" 
              class="px-3 py-1 text-sm rounded"
              :class="autoMode ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'">
        {{ autoMode ? 'Auto ON' : 'Auto OFF' }}
      </button>
    </div>

    <!-- Risk Level -->
    <div class="mb-4">
      <div class="flex justify-between items-center mb-2">
        <span class="text-sm font-medium">Risk Level</span>
        <span class="text-xs px-2 py-1 rounded bg-yellow-100 text-yellow-800">
          {{ riskLevel }}
        </span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-2">
        <div class="bg-yellow-500 h-2 rounded-full" :style="`width: ${riskPercentage}%`"></div>
      </div>
    </div>

    <!-- Zones -->
    <div class="mb-4">
      <h4 class="font-semibold mb-2">Control Zones</h4>
      <div class="grid grid-cols-2 gap-2">
        <div v-for="zone in zones" :key="zone.id" 
             class="p-2 border rounded text-sm">
          <div class="font-medium">{{ zone.name }}</div>
          <div class="text-gray-600">{{ zone.status }}</div>
          <div class="text-xs">{{ zone.area }} ha</div>
        </div>
      </div>
    </div>

    <!-- Weather -->
    <div class="mb-4">
      <h4 class="font-semibold mb-2">Weather</h4>
      <div class="grid grid-cols-3 gap-2">
        <div class="text-center p-2 bg-blue-50 rounded text-sm">
          <div>{{ weather.temp }}°C</div>
          <div class="text-xs">Temp</div>
        </div>
        <div class="text-center p-2 bg-blue-50 rounded text-sm">
          <div>{{ weather.humidity }}%</div>
          <div class="text-xs">Humidity</div>
        </div>
        <div class="text-center p-2 bg-blue-50 rounded text-sm">
          <div>{{ weather.wind }} km/h</div>
          <div class="text-xs">Wind</div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-2 gap-2">
      <button @click="emergencySpray" 
              class="px-3 py-2 bg-red-500 text-white rounded text-sm">
        Emergency Spray
      </button>
      <button @click="scheduleSpray" 
              class="px-3 py-2 bg-blue-500 text-white rounded text-sm">
        Schedule
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const autoMode = ref(false)
const riskLevel = ref('Medium')
const riskPercentage = ref(65)

const zones = ref([
  { id: 1, name: 'North Field', status: 'Active', area: 45 },
  { id: 2, name: 'East Field', status: 'Scheduled', area: 32 },
  { id: 3, name: 'South Field', status: 'Completed', area: 28 },
  { id: 4, name: 'West Field', status: 'Idle', area: 38 }
])

const weather = ref({
  temp: 28,
  humidity: 75,
  wind: 5
})

const emergencySpray = () => {
  console.log('Emergency spray activated')
}

const scheduleSpray = () => {
  console.log('Scheduling spray')
}
</script>
